import { MedHistoryIcon } from "../../icons.js";
import { relativeTime } from "../../../lib/time.js";
import type { WidgetProps } from "../types.js";

const SECTION_TYPES = [
  { key: "illness",             label: "Conditions" },
  { key: "vaccination",         label: "Immunizations" },
  { key: "visit",               label: "Visits" },
  { key: "surgery_or_procedure", label: "Procedures" },
  { key: "hospitalization",     label: "Hospitalizations" },
] as const;

export function MedicalHistoryWidget({ events, onNavigate }: WidgetProps) {
  const relevant = events.filter((e) =>
    SECTION_TYPES.some((s) => s.key === e.eventType)
  );
  const latest = relevant[0];

  return (
    <section className="rounded-xl border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 p-4">
      <div className="mb-2 flex items-center gap-2">
        <MedHistoryIcon size={16} className="text-(--accent)" />
        <h2 className="font-semibold text-gray-900 dark:text-gray-100">Medical history</h2>
        <button onClick={() => onNavigate("medical-history")} className="ml-auto text-xs text-(--accent) hover:underline">
          View
        </button>
      </div>
      {relevant.length === 0 ? (
        <p className="text-sm text-gray-400 dark:text-gray-500">No medical history recorded</p>
      ) : (
        <div className="space-y-1 text-sm text-gray-700 dark:text-gray-300">
          {SECTION_TYPES.map(({ key, label }) => {
            const count = events.filter((e) => e.eventType === key).length;
            if (count === 0) return null;
            return (
              <div key={key} className="flex justify-between">
                <span>{label}</span>
                <span className="font-medium text-gray-900 dark:text-gray-100">{count}</span>
              </div>
            );
          })}
          {latest && (
            <p className="border-t border-gray-100 dark:border-gray-800 pt-2 text-xs text-gray-400 dark:text-gray-500">
              Last updated {relativeTime(latest.occurredAt)}
            </p>
          )}
        </div>
      )}
    </section>
  );
}
